import React from 'react'
import {StripeBG, Icon} from '../../components'
import {Navbar} from '../../components/marketing'
import {DocToc} from '../../components/blog'

class Overview extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="DocPage">
        <StripeBG bg2={"white"} style="purple"/>
        <Navbar className="grid-restrain"/>
        <section className="grid-restrain grid-row full-8">
          <DocToc />
          <div className="content markdown-doc grid-item">
            <h1 className="title">Iframes</h1>
            <p>
              SnapTest playback execution can enter and exit iframes on your page. In order to accomplish this, use the "Enter frame" and "Exit frame" actions:
            </p>
            <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1622069591/docs/iframes/Screen_Shot_2021-05-26_at_5.52.09_PM.png" /></p>
            <p>Playback will move into the frame specified by the selector, and will continue until the "Exit frame" action
              is encountered.  If necessary, these may be nested for advanced "iframe in iframe" needs, just make sure
              to "exit frame" as many times as necessary.  </p>
            <p><b>If you are having difficulties entering a frame, remember the following:</b></p>
            <ul>
              <li>Increase the timeout of the "Enter Frame" action, which will continue looking for the iframe using the selector until completed.</li>
              <li>If you're entering an iframe immediately after loading a page, we recommend setting "Require Complete Load" setting on the "Load Page" action.</li>
            </ul>
          </div>
        </section>
      </div>
    )
  }

}

export default Overview;



// WEBPACK FOOTER //
// ./src/pages/doc/iframes.js